import type * as XLSXType from 'xlsx';
import type { ICsvBatchRow } from './terminal-operation-drawer.type';

export const MAX_SERIALS_PER_BATCH = 30;

const loadXLSX = (() => {
  let cached: Promise<typeof XLSXType> | null = null;
  return () => {
    cached ??= import('xlsx');
    return cached;
  };
})();

export const readWorkbook = async (file: File): Promise<XLSXType.WorkBook> => {
  const XLSX = await loadXLSX();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = e.target?.result;
        if (!data) { reject(new Error('empty')); return; }
        resolve(XLSX.read(data, { type: 'binary' }));
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = reject;
    reader.readAsBinaryString(file);
  });
};

export const extractSerialsFromWorkbook = async (workbook: XLSXType.WorkBook): Promise<string[]> => {
  const XLSX = await loadXLSX();
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows: Record<string, string>[] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
  return rows
    .map((row) => {
      const keys = Object.keys(row);
      const serialKey = keys.find((k) => /serial/i.test(k)) ?? keys[0];
      return String(row[serialKey] ?? '').trim();
    })
    .filter(Boolean);
};

export const extractCsvBatchRows = async (workbook: XLSXType.WorkBook): Promise<ICsvBatchRow[]> => {
  const XLSX = await loadXLSX();
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows: Record<string, string>[] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
  return rows
    .map((row) => {
      const keys = Object.keys(row);
      const serialKey = keys.find((k) => /serial/i.test(k)) ?? keys[0];
      const payfacKey = keys.find((k) => /payfac|company/i.test(k));
      const sellerKey = keys.find((k) => /seller/i.test(k));
      return {
        serialNumber: String(row[serialKey] ?? '').trim(),
        payfacId: payfacKey ? (Number(row[payfacKey]) || null) : null,
        sellerId: sellerKey ? (Number(row[sellerKey]) || null) : null,
      };
    })
    .filter((r) => r.serialNumber);
};
